module.exports = require("xml2js");


//////////////////
// WEBPACK FOOTER
// external "xml2js"
// module id = 13
// module chunks = 0